import React, { useEffect, useState } from "react";
import { X, Heart, Share2, Facebook } from "lucide-react";

// Bandeau de bienvenue ARNAK — affiché tous les 7 jours après login
// Demande aux membres de liker la page FB + de partager pour soutenir le collectif.
// Stocké en localStorage (clé: arnak_welcome_dismissed_at)

const STORAGE_KEY = "arnak_welcome_v2_at";
const COOLDOWN_DAYS = 7;

export const ArnakWelcomeBanner = ({ user, settings }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!user || !settings) return;
    const last = parseInt(localStorage.getItem(STORAGE_KEY) || "0", 10);
    const now = Date.now();
    if (!last || now - last > COOLDOWN_DAYS * 86400000) {
      // Léger délai pour ne pas balancer dès la première seconde
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, [user, settings]);

  if (!visible || !user) return null;

  const fbUrl    = settings?.facebook_page_url || settings?.fb_url || "https://www.facebook.com/arnak110";
  const shareUrl = typeof window !== "undefined" ? window.location.origin : "https://www.arnakclan.com";
  const shareTxt = "🔥 Découvre ARNAK, le collectif rap gasy de Madagascar 🇲🇬 → ";

  const close = () => {
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
    setVisible(false);
  };

  const onShare = async () => {
    const data = { title: "ARNAK — Rap Gasy", text: shareTxt, url: shareUrl };
    try {
      if (navigator.share) {
        await navigator.share(data);
      } else {
        // Fallback : Facebook share dialog
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}&quote=${encodeURIComponent(shareTxt)}`, "_blank", "noopener");
      }
    } catch (e) { /* user cancel */ }
  };

  const firstName = (user.name || "").split(" ")[0];

  return (
    <div
      className="fixed inset-x-0 top-0 z-[60] bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-400 text-black shadow-2xl animate-in slide-in-from-top duration-500"
      data-testid="arnak-welcome-banner"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-10 py-2.5 md:py-3 flex items-center gap-3 md:gap-5">
        <div className="hidden sm:flex w-10 h-10 md:w-12 md:h-12 rounded-full bg-black/15 items-center justify-center shrink-0">
          <Heart size={20} className="text-black" fill="currentColor" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-black text-sm md:text-base leading-tight">
            <span className="hidden sm:inline">Salut {firstName || "rappeur"} ! </span>
            <span className="sm:hidden">Yo ! </span>
            Aide-nous à grandir 🔥
          </p>
          <p className="text-[11px] md:text-xs opacity-85 leading-snug hidden sm:block">
            Like la page Facebook et partage arnakclan.com à un ami pour soutenir le collectif.
          </p>
        </div>
        <div className="flex items-center gap-1.5 md:gap-2 shrink-0">
          <a
            href={fbUrl}
            target="_blank"
            rel="noreferrer"
            onClick={close}
            className="inline-flex items-center gap-1.5 px-3 md:px-4 py-2 md:py-2.5 bg-[#1877F2] hover:bg-[#0e5fc2] text-white text-xs md:text-sm font-black uppercase tracking-wider rounded-full transition shadow-md whitespace-nowrap"
            data-testid="welcome-fb-like"
          >
            <Facebook size={14} fill="currentColor" /> <span className="hidden md:inline">J'aime</span><span className="md:hidden">Like</span>
          </a>
          <button
            type="button"
            onClick={onShare}
            className="inline-flex items-center gap-1.5 px-3 md:px-4 py-2 md:py-2.5 bg-black hover:bg-zinc-800 text-white text-xs md:text-sm font-black uppercase tracking-wider rounded-full transition shadow-md whitespace-nowrap"
            data-testid="welcome-share"
          >
            <Share2 size={14} /> Partager
          </button>
          <button
            type="button"
            onClick={close}
            className="p-2 -mr-1 rounded-full hover:bg-black/10 transition shrink-0"
            aria-label="Fermer"
            data-testid="welcome-close"
          >
            <X size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ArnakWelcomeBanner;
